// extracted by mini-css-extract-plugin
export var bottomGradient = "hero-module--bottomGradient--3ef00";
export var container = "hero-module--container--8217f";
export var greeting = "hero-module--greeting--1d939";
export var intro = "hero-module--intro--4de5f";
export var mobtnWrapper = "hero-module--mobtnWrapper--e09d4";
export var resume_link = "hero-module--resume_link--ce879";
export var textContainer = "hero-module--textContainer--6c070";